import * as apiAddCockpitReport from "@/api/cockpit/cockpitReports/addCockpitReport.js";
import * as apiDeleteCockpitReport from "@/api/cockpit/cockpitReports/deleteCockpitReport.js";

import * as apiGetCockpitReports from "@/api/cockpit/cockpitReports/getCockpitReports.js";
import * as apiUpdateCockpitReport from "@/api/cockpit/cockpitReports/updateCockpitReport.js";




import _ from "lodash";

export default {
    namespaced: true,
    state: {
        cockpitReports: null,
        categories: [
            { index: 0, name: "Cockpit Dashboard" },
            { index: 1, name: "Reporting by Week" },
            { index: 2, name: "Reporting by Month" },
            { index: 3, name: "Reporting by Year" },
            { index: 4, name: "Budgets" },
            { index: 5, name: "Campus" },
        ],
        categoryMap: [
            "Cockpit Dashboard",
            "Reporting by Week",
            "Reporting by Month",
            "Reporting by Year",
            "Budgets",
            "Campus"
        ],
    },
    mutations: {
        gotCockpitReports(state, result) {
            state.cockpitReports = result;
        },
    },
    actions: {

        async getAll({ commit, getters, dispatch }, force = true) {
            if (!force && getters.cockpitReports.length > 0) return;

            const result = await apiGetCockpitReports.get();
            if (result) {
                commit("gotCockpitReports", result);
                await dispatch("updateCockpitMenu", result, { root: true });
            }
        },

        async getCockpitReports({ commit, dispatch }) {
            const result = await apiGetCockpitReports.get();

            if (result) {
                commit("gotCockpitReports", result);
                await dispatch("updateCockpitMenu", result, { root: true });
            }
        },

        async addCockpitReport({ dispatch }, cockpitReport) {
            const result = await apiAddCockpitReport.post(cockpitReport);

            if (result) {
                await dispatch("getCockpitReports");
            }
        },

        async updateCockpitReport({ dispatch }, cockpitReport) {
            const result = await apiUpdateCockpitReport.put(cockpitReport);

            if (result) {
                await dispatch("getCockpitReports");
            }
        },

        async deleteCockpitReport({ dispatch }, id) {
            await apiDeleteCockpitReport.del(id);
            await dispatch("getCockpitReports");

        },
    },
    getters: {
        categories: state => state.categories,
        categoryMap: state => state.categoryMap,
        cockpitReports: state => state.cockpitReports,
        cockpitReport: state => (id) => state.cockpitReports.find(e => e.id === id),
    }
};
